(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('CheckoutEntityProfileForm', [
			'$filter',
			'FileUploadFactory',
			'globalConfig',
			'US_STATES',
			CheckoutEntityProfileFormFunction
		]);

	function CheckoutEntityProfileFormFunction(
		$filter,
		FileUploadFactory,
		globalConfig,
		US_STATES) {
		
		var checkout = this;

		checkout.formValues = globalConfig.formValues;
		checkout.entityTypes = angular.copy(globalConfig.entityTypes);
		checkout.taxClassifications = angular.copy(globalConfig.taxClassifications);
		checkout.tinTypes = angular.copy(globalConfig.tinTypes);
		checkout.states = angular.copy(US_STATES);
		checkout.formValues.entityType = $filter('findSelectedOption')(checkout.formValues.entityType, 'value', checkout.entityTypes, 'LLC');
		checkout.formValues.registrationState = $filter('findSelectedOption')(checkout.formValues.registrationState, 'abbreviation', checkout.states);
		checkout.formValues.taxClassification = $filter('findSelectedOption')(checkout.formValues.taxClassification, 'value', checkout.taxClassifications);
		
		checkout.formValues.state = $filter('findSelectedOption')(checkout.formValues.state, 'abbreviation', checkout.states);
		
		checkout.formation = FileUploadFactory.createStateObj('IDENTIFICATION_DOCUMENT');
		checkout.operating = FileUploadFactory.createStateObj('IDENTIFICATION_DOCUMENT');
		checkout.resetUpload = FileUploadFactory.resetUpload;
		checkout.uploadFiles = FileUploadFactory.uploadFiles;
		
		var taxClassificationsWithoutIndividual = [];

		angular.forEach(globalConfig.taxClassifications, function(classification){
			if (classification.value !== 'INDIVIDUAL') {
				taxClassificationsWithoutIndividual.push(classification);
			}
		});
		
		checkout.setTinType = function(){
			if (checkout.formValues.taxClassification.value === 'INDIVIDUAL') {
				checkout.formValues.tinType = 'SSN';
			} else {
				checkout.formValues.tinType = 'EIN';
			}
		};

		checkout.updateFormToReflectType = function(){
			if (checkout.formValues.entityType.value === 'SM_LLC') {
				setSingleMemberLLCValues();
			} else if (checkout.formValues.entityType.value === 'LLC') {
				setLLCValues();
			} else {
				setDefaultTaxClassification();
			}

			checkout.setTinType();
		};

		checkout.updateFormToReflectType();
		
		function setDefaultTaxClassification(){
			var taxClassificationValue;
			
			if (checkout.formValues.entityType.value === 'LP') {
				taxClassificationValue = 'PARTNERSHIP';
			} else if (checkout.formValues.entityType.value === 'C_CORP') {
				taxClassificationValue = 'C_CORP';
			} else if (checkout.formValues.entityType.value === 'S_CORP') {
				taxClassificationValue = 'S_CORP';
			} else {
				taxClassificationValue = checkout.formValues.entityType.value;
			}

			checkout.formValues.taxClassification = $filter('findSelectedOption')(taxClassificationValue, 'value', checkout.taxClassifications);
		}
		
		function setSingleMemberLLCValues(){
			checkout.taxClassifications = angular.copy(globalConfig.taxClassifications);

			checkout.formValues.taxClassification = $filter('findSelectedOption')('INDIVIDUAL', 'value', checkout.taxClassifications);
		}
		
		function setLLCValues(){
			checkout.taxClassifications = angular.copy(taxClassificationsWithoutIndividual);
			
			if (checkout.formValues.taxClassification.value === 'INDIVIDUAL') {
				checkout.formValues.taxClassification = checkout.taxClassifications[0];
			}
		}
	}
})(window.angular);